var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchPage page"},[_c('div',{staticClass:"container"},[_c('search-template')],1),_vm._v(" "),_c('LazyHydrate',{attrs:{"when-visible":{ rootMargin: '100px' }}},[_c('newsletter-home',{attrs:{"white":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }